export default customElements.define('w-loading-spinner', class LoadingSpinner extends wealthify.CustomElementBaseClass {

    constructor() {
        const config = {
            styleSelector: 'c-loading-spinner',
            templateHTML: `
                <div class="c-loading-spinner__container" data-root>
                    <div class="c-loading-spinner__background" data-background></div>
                    <div class="c-loading-spinner__spinner" data-spinner></div>
                </div>`,
            cacheDom: ['data-background', 'data-spinner']
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    static get validColours () {
        return [ 'black', 'primary-2'];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('absolute', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('blurbackground', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('colour', {
                default: 'primary-2',
                type: wealthify.propTypes.ArrayItem(this.validColours)
            })
        ];
    }

    get propCallbacks() {
        return {
            absolute: (setAbsolute) => {
                this.style.position = setAbsolute ? 'absolute' : 'static';
            },
            blurbackground: (applyBlur) => {
                const classListAction = applyBlur ? 'add' : 'remove';

                this.dom.background.classList[classListAction](`${this.styleSelector}--blur`);
            },
            colour: (colour) => {
                this.constructor.validColours.forEach((key) => this.dom.spinner.classList.remove(`${this.styleSelector}__spinner-color--${key}`));
                this.dom.spinner.classList.add(`${this.styleSelector}__spinner-color--${colour}`);
            }
        };
    }
});